/**
 * Clears all service worker caches and unregisters service workers. Preserves IndexedDB (user's video recordings) and localStorage. Forces a full page reload after clearing.
 *
 * @param {string} [redirectTo] Land here instead of reloading the current URL — for a screen reached
 *   by its own route (mobile Settings), reloading in place would drop the user back into that screen.
 */
export async function clearAppCache(redirectTo) {
	// Unregister all service workers
	if ('serviceWorker' in navigator) {
		const registrations = await navigator.serviceWorker.getRegistrations()
		await Promise.all(registrations.map(r => r.unregister()))
	}

	// Clear all Cache Storage API caches (Workbox caches)
	const cacheNames = await caches.keys()
	await Promise.all(cacheNames.map(name => caches.delete(name)))

	// Reload the page
	if (redirectTo) {
		location.replace(redirectTo)
	} else {
		location.reload(true)
	}
}

export default clearAppCache
